import React from 'react';
import { jc } from 'utils';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { variantImage } from './variant-image.styles';
import { useTranslation } from 'react-i18next';

export interface VariantImageDataProps {
  axis: string;
  src: string;
}

export const DATA_QA_IMAGE_PLACEHOLDER = 'image-placeholder';

type VariantImageProps = VariantImageDataProps & React.HTMLAttributes<HTMLDivElement>;

export const VariantImage: React.FC<VariantImageProps> = ({ src, axis, className = '' }) => {
  const { t } = useTranslation();
  return (
    <ImagePlaceholder
      className={jc(variantImage, className)}
      src={src}
      loading="lazy"
      alt={axis}
      fallbackAlt={t('ui.image.alt')}
      data-qa={DATA_QA_IMAGE_PLACEHOLDER}
      fallbackWidth={48}
      fallbackHeight={48}
    />
  );
};
